import apiClient from './apiClient'

apiClient.init(import.meta.env.VITE_ENERGY_DATA_URL)
const tokenStorageKey = 'energy_api_token'

const apiEnergy = {
  authenticate: async function (username, password) {
    let response = await apiClient.post('/users/auth', {
      username: username,
      password: password,
    })

    if (response.data.token) {
      this.setToken(response.data.token)

      return await this.me()
    }
  },
  me: async function () {
    return await apiClient.get(apiClient.url('/users/me'))
  },
  getToken: function () {
    return localStorage.getItem(tokenStorageKey)
  },
  setToken: function (token) {
    if (token) {
      localStorage.setItem(tokenStorageKey, token)
    }
    apiClient.setAuthenticationToken(token || this.getToken())
  },
  removeToken: function () {
    localStorage.removeItem(tokenStorageKey)
    apiClient.deleteAuthenticationToken()
  },
}

export default apiEnergy
